var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessSite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20H5C4.44772 20 4 19.5523 4 19V5C4 4.44772 4.44772 4 5 4H16C16.5523 4 17 4.44772 17 5V11",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8L14 8",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12L12 12",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7652 18.6181L19.2509 18.2316C19.3037 17.9969 19.33 17.7485 19.33 17.5C19.33 17.2239 19.3037 16.9479 19.2377 16.6856L19.7389 16.2991C19.9763 16.1196 20.0422 15.7607 19.8839 15.5123L19.6202 15.0706L19.3432 14.6426C19.1982 14.3942 18.8553 14.2975 18.6047 14.4494L18.0508 14.7531C17.7738 14.5184 17.4441 14.339 17.1012 14.2147L17.0485 13.5521C17.0353 13.2485 16.7847 13 16.4946 13H15.5054C15.2153 13 14.9647 13.2485 14.9383 13.5521L14.8988 14.2147C14.5295 14.3528 14.1866 14.546 13.8965 14.8083L13.3294 14.5046C13.0788 14.3666 12.7359 14.4632 12.5908 14.7117L12.3403 15.1534L12.0765 15.5951C11.9314 15.8574 11.9974 16.2163 12.2348 16.3819L12.7491 16.7684C12.6963 17.0031 12.67 17.2515 12.67 17.5C12.67 17.7761 12.7095 18.0383 12.7623 18.3006L12.2611 18.7009C12.0237 18.8804 11.9578 19.2393 12.1161 19.4877L12.3798 19.9294L12.6436 20.3574C12.8018 20.6058 13.1447 20.7025 13.3953 20.5506L13.9492 20.2331C14.2262 20.4678 14.5559 20.661 14.8988 20.7853L14.9383 21.4479C14.9647 21.7515 15.2153 22 15.5054 22H16.4946C16.7847 22 17.0353 21.7515 17.0485 21.4479L17.1012 20.7853C17.4705 20.6472 17.8134 20.454 18.1035 20.1917L18.6574 20.4954C18.9212 20.6334 19.2509 20.5368 19.4092 20.2883L19.6597 19.8466L19.9235 19.4049C20.0686 19.1426 20.0026 18.7837 19.7652 18.6181ZM15.9934 19.1564C15.123 19.1564 14.4108 18.411 14.4108 17.5C14.4108 16.589 15.123 15.8436 15.9934 15.8436C16.8638 15.8436 17.5892 16.589 17.5892 17.5C17.5892 18.411 16.877 19.1564 15.9934 19.1564Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessSite);
export default __webpack_public_path__ + "static/media/business_site.e1bf4d52984847e5da919360b697c198.svg";
export { ForwardRef as ReactComponent };